import React, { FC } from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Link,
} from '@mui/material';
import { Visibility, Star, Title, Delete } from '@mui/icons-material';
import { OneMedia } from '@prismamedia/one-components';
import { EditorState } from 'draft-js';
import { EditableListItem } from 'components/EditableListItem';
import { useStyles } from '../styles';

interface DrawerBlockProps {
  leadIn?: boolean | null;
  isAutoPromo?: boolean | null;
  url?: string | null;
  title?: string | EditorState | null;
  surTitle?: string | EditorState | null;
  content?: string | EditorState | null;
  onDeleteBlock?: () => void;
  onSetLeadIn?: () => void;
  onEditField?: (field: string, value: string | OneMedia | EditorState) => void;
}

export const DrawerBlock: FC<DrawerBlockProps> = ({
  leadIn,
  isAutoPromo,
  url,
  title,
  surTitle,
  content,
  onEditField,
  onSetLeadIn,
  onDeleteBlock,
}) => {
  const classes = useStyles();
  return (
    <>
      <List>
        <ListItem button onClick={onSetLeadIn}>
          <ListItemIcon className={classes.listItemIcon}>
            <Star color={leadIn ? 'primary' : 'inherit'} />
          </ListItemIcon>
          <ListItemText primary="Définir comme leader" />
        </ListItem>
      </List>
      <Divider />
      <List>
        {url && !isAutoPromo && (
          <ListItem
            button
            component={Link}
            href={url}
            target="_blank"
            className={classes.link}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <Visibility />
            </ListItemIcon>
            <ListItemText primary="Prévisualiser l'article" />
          </ListItem>
        )}
        {!isAutoPromo && (
          <>
            <EditableListItem
              content={title}
              multiline
              itemText="Modifier le titre"
              itemIconClass={classes.listItemIcon}
              onTextFieldChange={(value) =>
                onEditField && onEditField('title', value)
              }
            />
            <EditableListItem
              content={surTitle}
              multiline
              itemText="Modifier le chapô"
              itemIconClass={classes.listItemIcon}
              onTextFieldChange={(value) =>
                onEditField && onEditField('surTitle', value)
              }
            />
            <EditableListItem
              content={content}
              multiline
              itemText="Modifier le contenu"
              itemIconClass={classes.listItemIcon}
              onTextFieldChange={(value) =>
                onEditField && onEditField('content', value)
              }
            />
          </>
        )}
        {isAutoPromo && (
          <ListItem button>
            <ListItemIcon className={classes.listItemIcon}>
              <Title />
            </ListItemIcon>
            <ListItemText primary="Modifier le lien" />
          </ListItem>
        )}
        <ListItem button onClick={onDeleteBlock}>
          <ListItemIcon className={classes.listItemIcon}>
            <Delete />
          </ListItemIcon>
          <ListItemText primary="Supprimer" />
        </ListItem>
      </List>
    </>
  );
};
